import React, { Component } from 'react';
import { Button, Radio, Paper, Dialog, Fade, DialogContent, } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as actions from '../../actions';
import { Clear } from '@material-ui/icons';

class AddressPanel extends Component {
    constructor(props) {
        super();
        this.state = {
            selectedAddress: props.userData.addresses.length > 0
                ? props.userData.addresses.filter(
                    address => address.is_default == 1
                )[0]
                : '',
            showSelectAddress: false,
            changedAddress: ""
        };
    }
    componentDidMount() {
        console.log("Inside Address Panalllll:::::::", this.state.selectedAddress)

    }
    componentDidUpdate(prevProps) {
        if (
            prevProps.userData.addresses.length !=
            this.props.userData.addresses.length
        ) {
            if (this.props.userData) {
                this.setState({
                    selectedAddress: this.props.userData.addresses.filter(
                        address => address.is_default == 1
                    )[0]
                });
            }
        }
    }
    handleRadioChange = selectedAddress => () => {
        this.setState({ selectedAddress, showSelectAddress: false, changedAddress: selectedAddress}, () => {
            console.log("Selected Addressss::::", selectedAddress)
            this.props.setBookingAddress(selectedAddress);
        });
    };

    handleCloseAddress = () => {
        this.setState({
            showSelectAddress: false,
        })
    }

    render() {
        const { userData } = this.props;
        if (!this.state.selectedAddress) {
            return (
                <Paper elevation={2} style={{ paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, marginTop: 20 }}>
                    <div className="mb-2 mt-2">
                        <FormattedMessage
                            id="addDefaultAddress"
                            defaultMessage="Add atleast one default address to book service."
                        />
                        <br />
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => this.props.addNewAddress()}
                        >
                            <FormattedMessage
                                id="address.addnew"
                                defaultMessage="Add New"
                            />
                        </Button>
                    </div>
                </Paper>
            );
        }
        return (
            <Paper elevation={2} style={{ paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10, marginTop: 20 }}>

                {/* <div className="col-md-12 main-panel"> */}
                <div className="mb-4">
                      <h4 className="mb-2">
                        <FormattedMessage
                            id="address.choosetitle"
                            defaultMessage="Choose Address"
                        />
                    </h4>
                    <div style={{ flexDirection: "row", justifyContent: "space-between", display: "flex" }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => this.props.addNewAddress()}
                        >
                            <FormattedMessage
                                id="address.addnew"
                                defaultMessage="Add New"
                            />
                        </Button>

                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => this.setState({
                                showSelectAddress: true
                            })}
                        >
                            EDIT
                        </Button>
                    </div>
                </div>
                <div className="row">
                    {this.state.changedAddress == "" ?
                        userData.addresses.map((address, index) => {
                            if(address.is_default == 1){
                                return (
                                    <div
                                        className="col-md-12 col-sm-12 col-12 mb-4"
                                        key={index}
                                    >
                                        <div
                                            className="address-check main"
                                            sytle={{ display: 'flex' }}
                                            key={address.key}
                                        >
                                            <Radio
                                                checked={
                                                    address.key ==
                                                        this.state.selectedAddress.key
                                                        ? true
                                                        : false
                                                }
                                                onChange={this.handleRadioChange(
                                                    address
                                                )}
                                                value={
                                                    address.is_default == 1 
                                                        ? `0`
                                                        : `1`
                                                }
                                                color="primary"
                                                />
                                            <span>
                                                {address.name}, {address.phone},{' '}
                                                {address.address_line1},{' '}
                                                {address.city}, {address.state},{' '}
                                                {address.country}
                                            </span>
                                            
                                        </div>
                                    </div>
                                );
                            }else{
                                null
                            }
                           
                        }) :
                        <div
                            className="col-md-12 col-sm-12 col-12 mb-4"

                        >
                            <div
                                className="address-check"
                                sytle={{ display: 'flex' }}
                                key={this.state.changedAddress.key}
                            >
                                <Radio
                                    checked={
                                        this.state.changedAddress.key ==
                                            this.state.changedAddress.key
                                            ? true
                                            : false
                                    }
                                    /* onChange={this.handleRadioChange(
                                        this.state.changedAddress
                                    )} */
                                    value={
                                        this.state.changedAddress.is_default == 1
                                            ? `0`
                                            : `1`
                                    }
                                    color="primary"

                                />
                                <span>
                                    {this.state.changedAddress.name}, {this.state.changedAddress.phone},{' '}
                                    {this.state.changedAddress.address_line1},{' '}
                                    {this.state.changedAddress.city}, {this.state.changedAddress.state},{' '}
                                    {this.state.changedAddress.country}
                                </span>
                            </div>
                        </div>}
                </div>
                {this.state.showSelectAddress &&
                    <Dialog
                        fullWidth={true}
                        TransitionComponent={Fade}
                        disableBackdropClick={false}
                        className="login-modal"
                        open={this.state.showSelectAddress}
                        onBackdropClick={this.handleCloseAddress}
                        onClose={this.handleCloseAddress}
                        aria-labelledby="form-dialog-title"
                    >
                        <div className="md-12 pl-2 pr-2"
                            style={{ height: 60, display: "flex", justifyContent: "space-between", width: "100%", background: "#ffffff" }}>
                            <h4 style={{ alignSelf: "center", color: "#000000" ,padding:"20px 5px" }}>Choose Address</h4>
                            <Clear style={{ alignSelf: "center", color: "#000000" }} onClick={() => {
                                this.handleCloseAddress()
                            }} />

                        </div>
                        <div className="row pl-2 pr-2">
                            {userData.addresses &&
                                userData.addresses.map((address, index) => {
                                    return (
                                        <div
                                            className="col-md-6 col-sm-6 col-12 mb-4"
                                            key={index}
                                        >
                                            <div
                                                className="address-check new"
                                                sytle={{ display: 'flex' }}
                                                key={address.key}
                                            >
                                                <Radio
                                                    checked={
                                                        address.key ==
                                                            this.state.selectedAddress.key
                                                            ? true
                                                            : false
                                                    }
                                                    onChange={this.handleRadioChange(
                                                        address
                                                    )}
                                                    value={
                                                        address.is_default == 1
                                                            ? `0`
                                                            : `1`
                                                    }
                                                    color="primary"

                                                />
                                                <span>
                                                    {address.name}, {address.phone},{' '}
                                                    {address.address_line1},{' '}
                                                    {address.city}, {address.state},{' '}
                                                    {address.country}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>

                    </Dialog>}
                {/* </div> */}
            </Paper>
        );
    }
}

const mapStateToProps = ({ auth }) => {
    return { userData: auth.userData };
};
const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(withUser(AddressPanel));



// WEBPACK FOOTER //
// ./src/components/Booking/AddressPanel.jsx